import type {
  FeedbackImageAttachmentRef,
  GmResponseCommonFeedbackImageAttachmentRef,
  UploadFeedbackImageApiArg,
} from '~/api/generated-api';

type UploadFeedbackImageUnwrap = (
  arg: UploadFeedbackImageApiArg
) => Promise<GmResponseCommonFeedbackImageAttachmentRef>;

/**
 * Uploads each image in order and returns attachment payloads for
 * {@link FeedbackCreateRequest.imageAttachments}.
 */
export async function collectFeedbackImageAttachments(params: {
  files: File[];
  uploadFeedbackImage: UploadFeedbackImageUnwrap;
  'cs-organization': string;
  'cs-fleet'?: string;
}): Promise<FeedbackImageAttachmentRef[]> {
  const attachments: FeedbackImageAttachmentRef[] = [];

  for (const file of params.files) {
    const res = await params.uploadFeedbackImage({
      'cs-organization': params['cs-organization'],
      'cs-fleet': params['cs-fleet'],
      body: { file },
    });

    if (!res.success || !res.result?.blobName) {
      throw new Error('Feedback image upload failed');
    }

    attachments.push({
      blobName: res.result.blobName,
      contentType: res.result.contentType,
      sizeBytes: res.result.sizeBytes,
    });
  }

  return attachments;
}
